import { Checkbox, Modal } from '@surecompanies/core_components'
import React, { useEffect, useState } from 'react'

type ResumeEnrollmentModalProps = {
  open: boolean
  onConfirm: (clearCarts: boolean) => void
  onClose: () => void
  confirmLoading: boolean
}

export default function ResumeEnrollmentModal({
  open,
  onConfirm,
  onClose,
  confirmLoading,
}: ResumeEnrollmentModalProps) {
  const [clearCarts, setClearCarts] = useState(false)

  useEffect(() => {
    if (open) {
      setClearCarts(false)
    }
  }, [open])

  return (
    <Modal
      title="Resume Enrollment"
      open={open}
      onOk={() => onConfirm(clearCarts)}
      onCancel={onClose}
      confirmLoading={confirmLoading}
      okText="Resume"
    >
      <p>Resuming lets employees shop and elect benefits again.</p>
      <Checkbox
        checked={clearCarts}
        onChange={(e) => setClearCarts(e.target.checked)}
      >
        Also clear all carts
      </Checkbox>
      {clearCarts && (
        <p>
          <strong>
            This wipes elections and benefits for all employees and cannot be
            undone.
          </strong>
        </p>
      )}
    </Modal>
  )
}
